import { fetcher } from "utils";

import { OrderProductContactSerialized } from "typings";

export const get__members__order_product_contacts = (): Promise<OrderProductContactSerialized[]> =>
  fetcher.get("/members/order_product_contacts");
